export enum adminInvoiceDetailPostTypes {
    FETCH_ADMIN_INVOICE_DETAIL_POST_REQUEST = "FETCH_ADMIN_INVOICE_DETAIL_POST_REQUEST",
    FETCH_ADMIN_INVOICE_DETAIL_POST_SUCCESS = "FETCH_ADMIN_INVOICE_DETAIL_POST_SUCCESS",
    FETCH_ADMIN_INVOICE_DETAIL_POST_FAILURE = "FETCH_ADMIN_INVOICE_DETAIL_POST_FAILURE",
  }